import type { CriteriaChoiceUserType } from '~/model/CriteriaChoiceType';
import { criteriaFlagsTypes } from '~/const/appConst';

export const mandatoryCriteriaFlags = [
  criteriaFlagsTypes.USER_AGE,
  criteriaFlagsTypes.USER_GENDER,
  criteriaFlagsTypes.USER_DEPARTMENT,
];

export const hasMissingMandatoryCriteria = (
  criteria: CriteriaChoiceUserType[],
) => {
  return !mandatoryCriteriaFlags.every(flag =>
    criteria?.some(item => item.criterion.flag === flag),
  );
};

export const filterCriteriaByMandatoryFlags = (
  criteria: CriteriaChoiceUserType[],
) => {
  return criteria?.filter(item =>
    mandatoryCriteriaFlags.includes(item.criterion.flag),
  );
};
